/* eslint-disable */

export const switchStatusStrategyConstants = {
    SWITCH_STATUS_STRATEGY_REQUEST: 'SWITCH_STATUS_STRATEGY_REQUEST',
    SWITCH_STATUS_STRATEGY_SUCCESS: 'SWITCH_STATUS_STRATEGY_SUCCESS',
    SWITCH_STATUS_STRATEGY_FAILURE: 'SWITCH_STATUS_STRATEGY_FAILURE',
};
